import React from 'react'
import AdminDashboard from '../../components/admin/dashboard/admin-dashboard'
import AdminTemplate from '../../templates/admin-template'

const AdminDashboardPage = () => {
  return (
    <AdminTemplate>
      <AdminDashboard/>
    </AdminTemplate>
  )
}

export default AdminDashboardPage